export enum WebWorkerState {
  NDA_DOCUMENT = 'nda-document',
  DOWNLOAD_GIT_REPO = 'download-git-repo',
  DOWNLOAD_GIT_ERROR = 'download-git-error',
  DOWNLOAD_GIT_PROGRESS = 'download-git-progress',
  GIT_REPO = 'git-repo',
  ERROR_REPORT = 'error-report',
}

export enum WebWorkerPaths {
  NDA_DOCUMENT = '../../worker/cache/cache.worker.ts',
  GIT_REPO = '../../worker/git/git.worker.ts',
}

export interface WebWorkerData {
  type: WebWorkerState;
  value?: unknown;
}
